import React, { useEffect, useRef, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import QRCode from 'qrcode.react';
import { i18nIntl, formatNumber, getVerified, baseFake, getRemotedbUrl, colorToArray, isColorBright, RGB_2_HEX, getSoundPropsById, isNotEmpty, adaptHeightOnWidget } from '../../lib/ep.js';
import { shuffle as _shuffle } from 'lodash';

import ActionLink from '../builder/ActionLink';
import RoundSpinner from '../builder/RoundSpinner';
import SaveButton from '../builder/SaveButton';

import FloatingLayerPublic from '../front/FloatingLayerPublic';

import NextActionButton from '../games/NextActionButton';

import TriviaQuestion from './TriviaQuestion';

import LeveledHTMLText from './helpers/LeveledHTMLText.js';
import { FinalPage } from './GameContainer.js';
import GameContainerHeader from './GameContainerHeader.js';
import TimeCounterPerform from '../builder/TimeCounterPerform.js';
import { localizeFields } from '../builder/DynamicFields.js';

const Loading = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const greenRGB = 'rgba(120, 195, 0, 1)';
	const redRGB = 'rgba(215, 35, 60, 1)';
	const grayRGB = 'rgba(127, 127, 127, 0)';	// transparent

	const quiz_mode = props?.quiz_mode ?? '';

	const is_first_question = props?.is_first_question ?? false;
	const display_change_round = (props.display_change_round || (is_first_question && quiz_mode == 'allright')) ? true : false;
	const hide_score_resumee = props?.hide_score_resumee ?? false;

	const points_in_this_question = props?.points_in_this_question ?? 0;
	const bonus_in_this_question = props?.bonus_in_this_question ?? 0;

	const display_score_question = (!is_first_question && !display_change_round) ? true : false;
	const is_correct_answer = (points_in_this_question > 0) ? true : false;
	const bkg_color = (display_score_question) ? ((is_correct_answer) ? (props?.color_question_ok ?? greenRGB) : (props?.color_question_ko ?? redRGB)) : grayRGB;

	const color_hex = colorToArray(bkg_color, true);
	const is_light_color = isColorBright(RGB_2_HEX(`rgba(${color_hex[0]}, ${color_hex[1]}, ${color_hex[2]}, 1)`));

	const point_for_round = Math.max(props.points_per_hit - (props.decrease_points_per_round * props.round), 1);

	const is_last_question = (props.current + 1 > props.total_questions) ? true : false;
	let show_loading_of;
	switch(quiz_mode) {
		case 'allright':
			show_loading_of = (props.current != 0 && !is_last_question) ? true : false;
			break;

		case 'suddendeath':
			show_loading_of = (is_first_question || is_correct_answer) && !is_last_question ? true : false;
			break;

		default:
			show_loading_of = (!is_last_question) ? true : false;
			break;
	}

	const correct_answer = (props.correct_answer && quiz_mode != 'allright') ? props.correct_answer : false;
	const display_result_end = props?.display_result_end ?? false;

	const container_classes = ['is_verifying'];
	container_classes.push((is_correct_answer) ? 'is_ok' : 'is_ko');

	const points_in_question_classes = ['points_in_question'];
	points_in_question_classes.push((is_correct_answer) ? 'succeded ep-thumbs-up-empty' : 'failed ep-thumbs-down-empty');

	const container_styles = {
		'--stage-main-color':color_hex.join(", "),
		'--stage-main-color-variant':'var(--stage-main-color)',
		'--p-color':'var(--text-color)',
	};
	if(!is_first_question) {
		container_styles['--text-color'] = (is_light_color) ? '0, 0, 0, 1' : '255, 255, 255, 1';
	} else {
		container_styles['--text-color'] = 'var(--text-color-rgb), 1';
	}

	const correct_answer_styles = {
		'--text-color':'var(--stage-main-color)',
		'--background-color':(is_light_color) ? '0, 0, 0, 1' : '255, 255, 255, 1',
	};

	if(display_change_round) {
		return (
			<div class={container_classes.join(" ")} style={container_styles}>
				<div
					class="answers_in_question gui_pos_rel loading_msg"
					style={{ overflow:'visible' }}
				>
					{(!display_result_end) && (
						<div class="round_change_page">
							<span class="round_animated">{i18n("Round")} {(props.round + 1)}</span>

							<span class="round_animated_bg">
								<span />
							</span>

							<p>{i18n("Points for correct answer")}: {parseInt(point_for_round)}</p>

							<p>{i18n((props.round > 0) ? "Questions left" : "Total questions")}: {props.total_questions}</p>
						</div>
					)}
				</div>
			</div>
		)
	}

	return (
		<div class={container_classes.join(" ")} style={container_styles}>
			{(display_score_question && !is_first_question) && (
				<div class="question_text gained_points_display">
					<img src='/img/blank_55x34.png' width="100%" alt="" />

					<div class="answer_result is_fullscreen relative_to_container">
						<div class={points_in_question_classes.join(" ")} />

						{(is_correct_answer && hide_score_resumee === false) && (
							<div class="points_in_question score_in_question">
								<p>+{points_in_this_question} {i18n("points")}</p>
							</div>
						)}

						{(bonus_in_this_question > 0 && hide_score_resumee === false) && (
							<div class="bonus_in_question">
								<p>+{formatNumber(bonus_in_this_question)} {i18n("Bonus time", 'lowercase')}</p>
							</div>
						)}
					</div>
				</div>
			)}

			{(!display_result_end && show_loading_of) && (
				<LeveledHTMLText
					_class={{ other:`loading_msg${(is_first_question) ? ' first_question' : ''}` }}
				>
					<p>
						<FormattedMessage
							id="Loading question {current} of {total}"
							values={{
								current:(props.current + 1),
								total:props.total_questions,
							}}
						/>...
					</p>
				</LeveledHTMLText>
			)}

			{(correct_answer) && (
				<div
					class="answers_in_question gui_pos_rel loading_msg"
				>
					<div
						class="correct_answer_display original_color_item"
						style={correct_answer_styles}
					>
						<strong class="original_color_item">{correct_answer.answer}</strong>
					</div>
				</div>
			)}
		</div>
	)
};

const Wrapper = (props) => {
	const quiz_mode = props?.quiz_mode ?? false;
	const total_questions = props?.total_questions ?? 1;
	const current = (props.current != undefined) ? (props.decrease_current ? props.current - 1 : props.current) : 0;
	const bordered = props?.bordered ?? true;
	const display_string_timer = props?.display_string_timer ?? false;
	let empty_header = true;
	if(total_questions > 1) empty_header = false;
	if(display_string_timer !== false) empty_header = false;
	//if(quiz_mode && quiz_mode != 'allright') empty_header = true;

	let hide_header = props?.hide_header ?? false;
	
	const classname = [(!hide_header) ? 'timed_question_container' : 'not_timed_question_container'];
	if(bordered === false) classname.push('not_bordered');

	if(empty_header) hide_header = true;

	const main_classes = ['main_contents_flex', 'timed_quiz_c'];
	if(empty_header) main_classes.push('empty_header');

	return (
		<div class={main_classes.join(" ")}>
			{(!hide_header) && (
				<GameContainerHeader
					round={(quiz_mode && quiz_mode == 'allright') ? <strong>{props.round + 1}</strong> : null}
					score={(total_questions > 1) ? <strong>{`${((current >= 0) ? current : 0) + 1}/${total_questions}`}</strong> : false}
					score_label="Question"
					countdown={(display_string_timer) ? (
						<TimeCounterPerform
							ref={props.timer}
							stopped={true}
							//stopped={props.auto_stopped_timer}
							seconds={props?.time_question ?? 60}
							in_text={true}
							classes=''	// remove the "hasCountdown" class so it doesn't zoom the digits
						/>
					) : null}
				/>
			)}

			<div class={classname.join(" ")}>
				{props.children}
			</div>
		</div>
	)
};

const ScoreResumee = (props) => {
	const pr = props?.participate_result ?? { ranking:10 };
	const is_multiparticipation = props?.multiparticipation ?? false;
	const has_ranking = props?.has_ranking ?? false;
	const override_promo_styles = props?.override_promo_styles ?? false;

	const link = (props.stage == undefined) ? `/entries/${props.promo_id}` : `/entries/${props.promo_id}/#s:${props.stage.Stage.id}`;

	return (
		<div style={{ width:'100%', padding:'0 1.5em' }}>
			{(is_multiparticipation && pr != undefined && pr.ranking != undefined && has_ranking) && (
				<div class="position_in_ranking" style={(!override_promo_styles) ? { '--link-color':'var(--ep-white-color)' } : null}>
					<p>
						<FormattedMessage
							id="You are in position {pos} in the {ranking}"
							values={{
								pos:<strong>{pr.ranking}</strong>,
								ranking:<ActionLink
									_class={{ other:'original_color_item' }}
									_href={link}
								>Ranking</ActionLink>,
							}}
						/>
					</p>
				</div>
			)}

			<div class="game_resumee">
				<p>{props.title}:</p>

				<ul>
					{props.scoring_data.map((score, s) => {
						return (
							<li key={s}>
								<span>{score.label}:</span>

								<span>{score.value}</span>
							</li>
						)
					})}
				</ul>
			</div>
		</div>
	)
};

const TriviaClient = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const stage = props.stage?.Stage ?? props.stage;
	const promotion = props.promotion;

	const is_multiparticipation = props.multiparticipation;

	const quiz_mode = stage?.quiz_mode ?? '';

	const override_promo_styles = stage?.override_promo_styles ?? false;
	const instructions_disabled = stage?.instructions_disabled ?? false;
	const display_string_timer = stage?.display_string_timer ?? false;
	const hide_score_resumee = stage?.hide_score_resumee ?? false;

	const display_summary = (quiz_mode != 'allright') ? (stage?.display_summary ?? false) : false;

	const points_per_hit = (quiz_mode != 'allright' && stage.disable_bonus_time) ? (stage?.points_per_question ?? 100) : 100;
	const decrease_points_per_round = 20;
	const points_per_extra_second = 1;

	const silence = stage?.silence ?? false;

	const [ current, setCurrent ] = useState(0);
	const [ initialized, setInitialized ] = useState(false);
	const [ display_loading, setDisplayLoading ] = useState(false);
	const [ display_section_instructions, setDisplaySectionInstructions ] = useState((instructions_disabled === false) ? true : false);
	const [ display_section_gamescore, setDisplaySectionGamescore ] = useState(false);
	const [ display_summary_layer, setDisplaySummaryLayer ] = useState(false);
	const [ display_change_round, setDisplayChangeRound ] = useState(false);
	const [ game_valid, setGameValid ] = useState(true);
	const time_sent = useRef(0);
	const [ hash, setHash ] = useState(props.gp_hash);
	const [ correct_answer, setCorrectAnswer ] = useState(false);
	const [ display_result_end, setDisplayResultEnd ] = useState(false);
	const [ participate_result, setParticipateResult ] = useState({});
	const [ total_time, setTotalTime ] = useState(0);
	const [ round, setRound ] = useState(0);	//ONly for "allright" mode
	const [ questions, setQuestions ] = useState(props?.questions ?? []);	//ONly for "allright" mode
	const [ start_time, setStartTime ] = useState(0);
	const [ test_result, setTestResult ] = useState(false);
	
	const is_builder = props?.is_builder ?? false;
	const is_test = (is_builder) ? (props?.is_test ?? false) : false;
	
	const time_x_question = stage?.time_question ?? 10;
	const time_between_rounds = 4.2;
	const time_between_questions_success = 3.5;
	const time_between_questions_fail = 1.5;
	const time_between_questions_end = 1;
	const time_extra_show_correct_answer = 1;
	
	const user = useRef({});
	const encerts = useRef(0);
	const remaining_questions = useRef([]);
	const points_in_this_question = useRef(0);
	const bonus_in_this_question = useRef(0);
	const points_per_time = useRef(0);
	const points_per_answer = useRef(0);
	const total_questions_initial = useRef(props.questions.length);
	const time_between_questions = useRef(time_between_questions_success);
	const first_timer = useRef(null);
	const is_submitting = useRef(false);
	const timer = useRef();

	const sound_success = (silence === false) ? new Howl({ ...getSoundPropsById('success') }) : false;
	const sound_error = (silence === false) ? new Howl({ ...getSoundPropsById('oh') }) : false;
	const sound_applause = (silence === false) ? new Howl({ ...getSoundPropsById('applause') }) : false;
	const sound_in_hell = (silence === false) ? new Howl({ ...getSoundPropsById('evil_laugh') }) : false;
	
	const goodResult = () => {
		if(silence) return;
		sound_success.play();
	};

	const badResult = () => {
		if(silence) return;
		sound_error.play();
	};

	const goodEnd = () => {
		if(silence) return;
		sound_applause.play();
	};

	const oopsYouDied = () => {
		if(silence) return;
		sound_in_hell.play();
	};

	const calculatePartialPoints = (answer, time_answered) => {
		const question_id = questions[current].Question.id;
		const search_question = questions.find((q) => (q.Question.id == question_id));
		const search_answer = (search_question.Answer).find((a) => (a.id == answer.id && a.correct == '1'));

		const is_correct = (search_answer != undefined) ? true : false;
		let correct_answer = false;

		if(is_correct) {
			points_in_this_question.current = parseInt(Math.max(points_per_hit - (decrease_points_per_round * round), 1));
			points_per_answer.current += points_in_this_question.current;

			const disable_bonus_time = stage?.disable_bonus_time ?? false;

			bonus_in_this_question.current = (disable_bonus_time) ? 0 : Math.max(time_x_question - time_answered, 0) * points_per_extra_second;
			points_per_time.current += bonus_in_this_question.current;

			time_between_questions.current = time_between_questions_success;
			setCorrectAnswer(false);
		} else {
			points_in_this_question.current = 0;
			bonus_in_this_question.current = 0;

			time_between_questions.current = time_between_questions_fail;
			if(stage?.show_correct_answer ?? false) {
				correct_answer = (search_question.Answer).find((a) => (a.correct == '1'));
				time_between_questions.current += time_extra_show_correct_answer;
			}
		}

		setCorrectAnswer(correct_answer);

		return is_correct;
	};

	const registerUserQuestion = (answer, value) => {
		if(is_test && quiz_mode == 'allright') {
			const index = Object.keys(user.current).length;
			value.question_id = questions[current].Question.id;
			user.current[index] = { [answer.id]:value };
		} else {
			user.current[questions[current].Question.id] = { [answer.id]:value };
		}

		if(props.onAnswer != undefined) props.onAnswer(user.current);
	};
 
	const setAnswerTimeAndPoints = (answer, time_answered) => {
		setTotalTime(total_time + time_answered);

		// right or Wrong but clicked or not
		const is_correct = calculatePartialPoints(answer, time_answered);

		if(is_correct) {
			encerts.current = encerts.current + 1;
			goodResult();
		} else {
			badResult();
		}

		let answer_result = {};
		switch(quiz_mode) {
			case 'allright':
				answer_result = {
					round,
				};
				if(is_correct) {
					if(is_test) {
						answer_result.points = points_in_this_question.current;
						answer_result.correct = is_correct;
						answer_result.current = current;
					}

					registerUserQuestion(answer, answer_result);
				} else {
					remaining_questions.current.push(questions[current]); // add for next round

					if(is_test) {
						answer_result.points = 0;
						answer_result.correct = false;
						answer_result.current = current;
						registerUserQuestion(answer, answer_result); // show in sidebar only when test fail
					}
				}
				break;

			case 'suddendeath':
			default:
				answer_result = (is_test) ? { correct:is_correct, points:points_in_this_question.current, current } : 1;
				registerUserQuestion(answer, answer_result);
				break;
		}

		return is_correct;
	};

	const displayEndResult = (quiz_mode, cb) => {
		if(quiz_mode == 'allright') {
			if(cb != undefined) cb();
			return;
		}

		setDisplayResultEnd(true);

		setTimeout(() => {
			if(cb != undefined) cb();
		}, (time_between_questions_end * 1000));
	};

	const nextQuestion = (new_round = false) => {
		setDisplayLoading(true);
		setCurrent((new_round) ? 0 : current + 1);

		setTimeout(() => {
			if(new_round) {
				setRound(round + 1);
				setDisplayChangeRound(true);

				setTimeout(() => {
					setDisplayLoading(false);
					setDisplayChangeRound(false);
					if(display_string_timer && timer.current != 0) timer.current.resetTimer(true);
				}, (time_between_rounds * 1000));
				return;
			}

			setDisplayLoading(false);
			if(display_string_timer && timer.current != 0) timer.current.resetTimer(true);
		}, (time_between_questions.current * 1000));
	};

	const goToEndGame = (valid) => {
		setDisplayLoading(false);

		if(!valid) return;

		setDisplaySectionGamescore(true);

		if(encerts.current == total_questions_initial.current) {
			goodEnd();
			return;
		}

		if(quiz_mode == 'suddendeath') {
			oopsYouDied();
		}
	};

	const toAnswer = (answer, answered = true) => {
		if(is_builder && !is_test) return;

		const time_counter_up = time_x_question - first_timer.current.getTimeUp();

		if(display_string_timer) timer.current.getElapsedAndStop();

		const time_answered = (answered) ? time_counter_up : time_x_question;

		const is_correct = setAnswerTimeAndPoints(answer, time_answered);
		const ended_questions_in_round = ((current + 1) >= questions.length) ? true : false;
		const has_remaining_questions = (remaining_questions.current.length > 0) ? true : false;

		if(quiz_mode == 'allright' && ended_questions_in_round && has_remaining_questions) {
			// ended ROUND BUT MISSED ANSWERS
			let renew_questions = [ ...remaining_questions.current ];
			if(stage.random_answers) {
				renew_questions.map((q, index) => {
					renew_questions[index].Answer = _shuffle(q.Answer);
				});
			}
			if(stage.random_questions) {
				renew_questions = _shuffle(renew_questions);
			}

			remaining_questions.current = [];
			setQuestions(renew_questions);
			nextQuestion(true);
			return;
		}

		//Default
		if(ended_questions_in_round || (quiz_mode == 'suddendeath' && !is_correct)) {
			// Ended game or wrong aswer with "sudden death" mode ON
			let completed = is_correct;
			if(!['suddendeath','allright'].includes(quiz_mode)){
				completed = true;
				const minim_encerts_completed = Math.min((stage?.quiz_answered_correctly ?? total_questions_initial.current),(stage?.max_questions ?? questions.length));
				if(encerts.current < minim_encerts_completed){
					completed = false;
				}
			}
		
			displayEndResult(quiz_mode, () => {
				goToEndGame(true);
				if(is_test) {
					setTimeout(() => {
						setDisplayResultEnd(false);
						setTestResult(true)
					},1500);
					return;
				}

				resultAction((res_2) => {
					if(!res_2.status) {
						goToEndGame(false);
						return;
					}
					props.submitQuiz(points_per_answer.current + points_per_time.current, user.current, (res) => {
						if(res.next_participation != undefined) {
							const next_participation = res.next_participation;
							if(next_participation !== false && next_participation !== true) {
								const time_to_next_participation = EPDateDuration(EPDateDiff(next_participation));
								res.next_participation = EPDateHumanize(time_to_next_participation);
							}else{
								res.next_participation = next_participation;
							}
						}
						setDisplayResultEnd(false);
						setParticipateResult(res);
					},res_2, time_sent.current, hash, completed);
				});
			});

			return;
		}

		nextQuestion();
	};

	const resultAction = (cb) => {
		const time_counter_total = (Date.now() - start_time) / 1000;
		time_sent.current = time_counter_total;
		const send_data = {
			info:baseFake(getVerified({
				solved:true,
				time:time_counter_total,
				time_questions:total_time,
				timegame:questions.length * time_x_question,
				hash,
				score_total:points_per_answer.current + points_per_time.current,
			})),
			page:`stage_${stage.id}`,
			type:'gameplay',
		};

		$.post(getRemotedbUrl(`/promotions/action/${promotion.id}`), send_data, (res) => {
			setGameValid((res.status == 0) ? false : true);
			if(cb != undefined) cb(res);
		}, 'JSON');
	};

	const timeToAnswerCompleted = () => {
		// not answered;
		toAnswer({ id:false, question_id:questions[current].Question.id }, false);
	};

	const setInitGame = (cb) => {
		if(is_builder && !is_test) {
			if(cb != undefined) cb();
			return;
		}

		const send_data = {
			info:baseFake(getVerified({
				hash:props.gp_hash,
				has_countdown:false,
			})),
			type:'gamestart',
		};

		setTimeout(() => {
			setDisplaySectionInstructions(false);

			const delay_time = (quiz_mode == 'allright') ? time_between_rounds : 1.5;

			if(is_test) {
				setTimeout(() => {
					if(display_string_timer && timer.current != 0) timer.current.resetTimer(true);
					setInitialized(true);

					if(cb != undefined) cb();
				}, (delay_time * 1000));
				return;
			}

			const before_ajax = Date.now();
			$.post(getRemotedbUrl(`/promotions/action/${promotion.id}`), send_data, (res) => {
				const after_ajax = Date.now()
				const seconds = ((after_ajax - before_ajax) / 1000).toFixed(3);
				setStartTime(after_ajax);

				setTimeout(() => {
					setHash(res.hash);
					if(display_string_timer && timer.current != 0 && timer.current != undefined) timer.current.resetTimer(true);
					setInitialized(true);

					if(cb != undefined) cb(res);
				}, ((delay_time - seconds) * 1000));
			}, 'JSON');
		}, 1000);
	};

	useEffect(() => {
		if(is_builder && !is_test) return;
		if(instructions_disabled) setInitGame(() => {});
	}, []);

	const continueGame = (e) => {
		if(is_submitting.current) return;
		is_submitting.current = true;

		if(participate_result != undefined && participate_result.url != undefined) {
			window.location.href = participate_result.url;
			return;
		}
	};

	const display_instructions = ((display_section_instructions || props.force_instructions) && !props.force_gamescore && !props.force_gamesummary && !props.force_game) ? true : false;
	const display_gamescore = (display_section_gamescore || props.force_gamescore) && !props.force_instructions && !props.force_gamesummary && !props.force_game ? true : false;
	const display_gamesummary = (props.force_gamesummary && !props.force_instructions && !props.force_gamescore && !props.force_game && quiz_mode != 'allright') ? true : false;

	const summary = [];
	let total_hits = 0;
	const scoring_data = [];

	if(display_gamescore || display_gamesummary) {
		questions.map((question) => {
			let insert_question = false;
			const obj_summary = {
				q:question.Question.question,
			};

			if(quiz_mode == 'allright') {
				total_hits++; // no summary needed
			} else if(user.current[question.Question.id] != undefined) {
				const answer_id = Object.keys(user.current[question.Question.id])[0];
				const search_answer = (question.Answer).find((a) => (a.id == answer_id));
				let correct = false;
				if(search_answer && search_answer.correct == '1') {
					total_hits++;
					correct = true;
				}

				obj_summary.a = search_answer ? search_answer.answer : i18n("No answer");
				obj_summary.correct = correct;
				insert_question = true;
			} else if(quiz_mode != 'suddendeath') {
				obj_summary.a = i18n("No answer");
				obj_summary.correct = false;
				insert_question = true;
			}

			if(insert_question) summary.push(obj_summary);
		});
	}

	const wrapper_props = {
		is_builder,
		color_bar:stage.color_question_ko,
		current,
		quiz_mode,
		round,
		timer,
		auto_stopped_timer:(is_builder && !is_test) ? true : false,
		display_string_timer,
		time_question:stage?.time_question ?? 10,
		started:initialized,
		bordered:stage?.display_outter_border ?? true,
		total_questions:questions.length,
		decrease_current:(display_loading === true) ? true : false,
		intl:props.intl,
	};

	const loading_props = {
		color_question_ok:stage.color_question_ok,
		color_question_ko:stage.color_question_ko,
		current,
		bonus_in_this_question:bonus_in_this_question.current,
		points_in_this_question:points_in_this_question.current,
		correct_answer,
		display_result_end,
		quiz_mode:quiz_mode,
		round,
		total_questions:questions.length,
		points_per_hit:points_per_hit,
		decrease_points_per_round,
		display_change_round,
		hide_score_resumee,
		intl:props.intl,
	};

	useEffect(() => {
		setTimeout(() => {
			adaptHeightOnWidget();
		}, 200);
	}, [
		display_instructions,
		display_gamescore,
	]);

	if(display_loading === true || display_result_end === true) {
		return (
			<Wrapper {...wrapper_props}>
				<Loading
					{...loading_props}
				/>
			</Wrapper>
		)
	}

	if(game_valid !== true) {
		return (
			<Wrapper {...wrapper_props}>
				<div style={{backgroundColor:'#000'}}>
					<div class="game_result override_styles is_verifying is_ko" style={{backgroundColor:'#000'}}>
						<div class="flex_button gui_big_button gui_custom_color gui_withoutEvents">
							<div class="icon_container">
								<div class="icon ep-thumbs-down-empty" />
							</div>
							
							<LeveledHTMLText
								_class={{ other:'status_title' }}
							>
								{`<h1>${i18n("Invalid game")}</h1>`}
							</LeveledHTMLText>

							<div class="is_qr">
								<QRCode value={hash} size={150} />
							</div>
						</div>
					</div>
				</div>
			</Wrapper>
		)
	}

	if(display_instructions) {
		const button_label = (isNotEmpty(stage, 'instructions_button')) ? stage.instructions_button : i18n("Start");

		let text_mode = "The game ends when you have answered all the questions. Get as many questions right as fast as possible.";
		switch(quiz_mode) {
			case 'suddendeath':
				text_mode = "The game ends when you get a question wrong. Get as many questions correct as possible.";
				break;

			case 'allright':
				text_mode = "The game ends when you have answered all the questions correctly. You have multiple rounds and in each one, you will see the questions that you got wrong in the previous round.";
				break;
		}

		return (
			<article class="quiz_instructions gui_main_text_color_on_bg">
				<div>
					{(stage.instructions_img) && (
						<img class="instructions_img" src={stage.full_instructions_img} alt="" />
					)}

					{(isNotEmpty(stage, 'instructions_description')) && (
						<LeveledHTMLText
							_class={{ other:'fill_description' }}
						>{stage.instructions_description}</LeveledHTMLText>
					)}

					<div class="instruction_tips">
						<div>
							<p>
								<strong class="knk-videogame gui_small_icon">{i18n("Game mode")}:</strong>
								<span>{i18n(text_mode)}</span>
							</p>

							<p>
								<strong class="knk-questions gui_small_icon">{i18n("Number of questions")}:</strong>
								<span>{questions.length}</span>
							</p>

							<p>
								<strong class="knk-loading gui_small_icon">{i18n("Time per question")}:</strong>
								<span>{stage?.time_question ?? 10} {i18n("seconds")}</span>
							</p>
						</div>
					</div>

					<div class="instructions_cta">
						<div class="gui_big_button flex_button">
							<SaveButton
								_fullclass=""
								onClick={(e, cb) => setInitGame(cb)}
								autotranslate={false}
							>{button_label}</SaveButton>
						</div>
					</div>
				</div>
			</article>
		)
	}

	if(display_gamescore) {
		const display_right_or_wrong_summary = stage?.display_right_or_wrong_summary ?? false;
		const summary_message = (isNotEmpty(stage, 'end_summary')) ? stage.end_summary : `<p>${i18n((display_right_or_wrong_summary) ? "These are the answers" : "These are your answers")}<p>`;

		if(quiz_mode != 'allright') {
			const label_hits = i18n("Correct answers");
			if(is_builder && !is_test) {
				scoring_data.push({
					label:label_hits,
					value:`${questions.length}/${questions.length}`,
				});
			} else {
				scoring_data.push({
					label:label_hits,
					value:`${total_hits}/${questions.length}`,
				});
			}
		}

		const label_score = i18n("score", 'ucfirst');
		const label_bonus = i18n("Bonus time");
		const label_total = i18n("Total score");

		if(is_builder && !is_test) {
			const total_points_builder_notest = points_per_hit *  questions.length;
			const total_bonus_builder_notest = (stage.time_question - 2) * questions.length;

			scoring_data.push({
				label:label_score,
				value:formatNumber(total_points_builder_notest),
			});

			if(stage.disable_bonus_time == undefined || !stage.disable_bonus_time) {
				scoring_data.push({
					label:label_bonus,
					value:formatNumber(total_bonus_builder_notest),
				});
			}

			scoring_data.push({
				label:label_total,
				value:formatNumber(total_points_builder_notest + total_bonus_builder_notest),
			});
		} else {
			scoring_data.push({
				label:label_score,
				value:formatNumber(points_per_answer.current),
			});

			if(stage.disable_bonus_time == undefined || !stage.disable_bonus_time) {
				scoring_data.push({
					label:label_bonus,
					value:formatNumber(points_per_time.current),
				});
			}

			scoring_data.push({
				label:label_total,
				value:formatNumber(points_per_answer.current + points_per_time.current),
			});
		}

		const fucking_master = (encerts.current == total_questions_initial.current) ? true : false;

		const final_case = props?.final_case ?? 'success';

		let type = 'success';
		let default_final_message = {
			id:'success',
			text:stage?.end_score ?? `<h1>${i18n("Thank you for playing!")}</h1>`,
			color:stage?.color_score ?? 'rgba(120, 195, 0, 1)',
			image:stage?.game_final_image_ok ?? false,
			full_image:stage?.full_game_final_image_ok ?? false,
		};

		let is_fail = false;
		if((quiz_mode == 'suddendeath' && !fucking_master && (!is_builder || is_test)) || (is_builder && !is_test && final_case == 'fail')) {
			type = 'fail';
			is_fail = true;
			default_final_message = {
				id:'death',
				text:`<h1>${i18n("Game over!")}</h1>`,
				color:'rgba(215, 35, 60, 1)',
				image:false,
				full_image:false,
			};
		}
		if(!['suddendeath','allright'].includes(quiz_mode) && encerts.current < Math.min((stage?.quiz_answered_correctly ?? total_questions_initial.current),stage.max_questions)){
			type = 'fail';
			is_fail = true;
			default_final_message = {
				id:'death',
				text:`<h1>${i18n("Game over!")}</h1>`,
				color:'rgba(215, 35, 60, 1)',
				image:false,
				full_image:false,
			};
		}

		const final_message = stage?.final_messages != undefined ?  localizeFields(stage?.final_messages,props.locale).find((t) => t.id == type) : default_final_message;

		const has_ranking = (promotion.has_ranking && promotion.public_entries == '1') ? true : false;

		const has_something_to_display = (Object.keys(participate_result).length > 0 || (test_result && is_test) || hide_score_resumee === false) ? true : false;

		return (
			<Wrapper hide_header={true} {...wrapper_props}>
				<FinalPage
					final_message={final_message}
					multiparticipation={is_multiparticipation}
					game={{
						scores:scoring_data,
						participate_result
					}}
					use_new_design={true}
					override_promo_styles={override_promo_styles}
					score_resumee={<>
						{(has_something_to_display || is_builder) && (
							<div class="score_resumee">
								{(hide_score_resumee === false) && (
									<ScoreResumee
										title={i18n("Results")}
										scoring_data={scoring_data}
										participate_result={participate_result}
										has_ranking={has_ranking}
										multiparticipation={is_multiparticipation}
										override_promo_styles={override_promo_styles}
										promo_id={promotion.id}
									/>
								)}

								{(display_summary && quiz_mode != 'allright') && (
									<div class="gui_not_in_top">
										<p>
											<ActionLink
												onClick={(!is_builder || is_test) ? () => setDisplaySummaryLayer(true) : null}
												_class={{ other:'gui_not_in_top_small' }}
											>Show summary</ActionLink>
										</p>
									</div>
								)}
							</div>
						)}

						{(!has_something_to_display) && (
							<div class="gui_not_in_top_huge">
								<RoundSpinner
									fullscreen={false}
									data={{ color:'#FFFFFF' }}
								/>
							</div>
						)}
					</>}
				>
					{(has_something_to_display) && (
						<NextActionButton
							custom_color={final_message.color}
							multiparticipation={is_multiparticipation}
							login_type={promotion.login_type}
							status={(is_fail === false) ? 'ok' : 'ko'}
							allow_retry={true}
							retries={participate_result.retries}
							prize={participate_result.prize}
							next_participation={participate_result.next_participation}
							continueGame={continueGame}
							restartGame={() => props.canPlayAgain()}
							is_builder={is_builder}
							allow_ranking={(has_ranking) ? true : false}
							promotion_id={promotion.id}
							override_promo_styles={override_promo_styles}
							intl={props.intl}
						/>
					)}
				</FinalPage>

				{(display_summary_layer) && (
					<FloatingLayerPublic
						pm={promotion}
						is_builder={is_builder}
						enable_behavior={true}
						title={`<h1>${i18n("Answer summary")}</h1>`}
						backButton={() => setDisplaySummaryLayer(false)}
					>
						<LeveledHTMLText>{summary_message}</LeveledHTMLText>

						<div
							class={`answered_resume${(display_right_or_wrong_summary) ? ' with_feedback' : ''}`}
						>
							{summary.map((q, i) => {
								const classes = ['a'];
								if(display_right_or_wrong_summary) {
									classes.push(`${(q.correct) ? 'ep-check-list-item greenIcon' : 'ep-delete-circle redIcon'}`);
								}

								return (
									<div key={`s${i}`}>
										<div class="q">
											<strong>{q.q}</strong>
										</div>

										<div class={classes.join(" ")}>{q.a}</div>
									</div>
								)
							})}
						</div>
					</FloatingLayerPublic>
				)}
			</Wrapper>
		)
	}

	const time_counter_props = {
		key:(questions.length > 0 && questions[current] != undefined) ? `timer-${questions[current].Question.id}` : `timer-unnamed`,
		ref:first_timer,
		enable_animation:(is_builder && !is_test) ? false : true,
		seconds:stage.time_question,
		onEnd:timeToAnswerCompleted,
	};

	if(!(initialized || (is_builder && !is_test))) {
		return (
			<Wrapper {...wrapper_props} round={round}>
				<Loading
					is_first_question={(current < 1 && round == 0) ? true : false}
					{...loading_props}
				/>
			</Wrapper>
		)
	}

	let answers_in_question = [];
	if(questions.length > 0 && questions[current] != undefined && questions[current].Answer) {
		answers_in_question = questions[current].Answer;
	}

	return (
		<Wrapper {...wrapper_props} round={round}>
			<TriviaQuestion
				time_counter_props={time_counter_props}
				question={questions[current]}
				answers={answers_in_question}
				total_questions={questions.length}
				current={current}
				answer_click={toAnswer}
				title={props.title}
				apply_autogrow={(current < 1) ? true : false}
			/>
		</Wrapper>
	)
};

export default injectIntl(TriviaClient);